'use strict';

function CreditScoreInterstitial() {
  this.id = null;
  this.node = null;
  this.extends = [_CreditScoreController, Interstitial];

  this.contentId = ''; // 'credit-score' (defined in pug file)

  this.init = function () {
    this._super();
    this.viewedOnceCheck();
  };

  this.viewedOnceCheck = function () {
    // user must view interstitial content only once
    var MEMBER_CONTENTS_KEY = this.contentId + '-interstitial';
    if (this._productSettings.hasViewedContent(MEMBER_CONTENTS_KEY)) {
      this.history = new History();
      this.history.replaceUrl(Product.shortcutMappings[this.contentId + '-overview']);
    } else {
      this.initPage();
    }
  };

  this.initPage = function () {
    this.initInterstitial();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyInterstitial();
  };
}